import React, { useState, useEffect } from 'react';
import { Snackbar, SnackbarCloseReason, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useAlertContext } from '../../context/alertContext';

const Alert: React.FC = () => {
	const { alert, setAlert } = useAlertContext();
	const [open, setOpen] = useState(alert !== '');

	useEffect(() => {
		setOpen(alert !== '');
	}, [alert]);

	const handleClose = (event: unknown, reason?: SnackbarCloseReason): void => {
		if (reason === 'clickaway') {
			return;
		}

		setAlert('');
	};

	return (
		<Snackbar
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'center'
			}}
			open={open}
			autoHideDuration={5000}
			onClose={handleClose}
			message={alert}
			action={
				<React.Fragment>
					<IconButton size='small' aria-label='close' color='inherit' onClick={handleClose}>
						<CloseIcon fontSize='small' />
					</IconButton>
				</React.Fragment>
			}
		/>
	);
};

export default Alert;
